<template>
	<div class="hi-footer">
		<!-- 关于我们 -->
		<div class="">
			<img src="@/assets/imgs/index/about.png" alt="" />
		</div>
		<!-- 备案 -->
		<div class="hi-record-section">
			信之家信用服务（北京）有限公司版权所有
			备案号：<a href="https://beian.miit.gov.cn" target="_blank">京ICP备2023033049号-1</a>
			<br>
			<img class="foot-icon" src="@/assets/imgs/foots/jing.png" alt="" />
			<a href="https://beian.mps.gov.cn" target="_blank">京公网安备11010902001024号</a>
			
			<div style="width: 100%;height: 3.3rem;"></div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		props: {
			// 距离底部距离
			mbottom: {
				type: [String, Number],
				default: 0
			},
			// 内容数据
			item: {
				default: () => []
			}
		},
		methods: {
			
		}
	}
</script>

<style>
	
</style>
